<div class="w-100 d-flex align-items-center justify-content-between">
    <div class="w-100 d-flex my-1 align-items-center" [title]="HsLayerUtilsService.translateTitle(layer.title)">
        <input type="radio" class="mr-3" [checked]="layer.visible" (change)="layerSelected(layer)"
            id="aclayer-{{layer.uid}}" name="aclayer-{{layer.uid}}">
        <label class="m-0 pr-2 text-truncate w-100"
            for="aclayer-{{layer.uid}}">{{HsLayerUtilsService.translateTitle(layer.title)}}</label>
    </div>
</div>
<div class="dropdown-divider w-100"></div>